import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Funcao } from '../../components'
import * as funcaoActionCreators from '../../redux/modules/funcao'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class FuncaoContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleFuncao: PropTypes.object,
    fetchMultipleFuncao: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroyFuncao: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleFuncao()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/funcoes/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/funcoes/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyFuncao(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  handleSort = column => () => this.props.updateSort('funcao', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('funcao', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleFuncao.toList().toJSON(),
      'funcao',
      ['id', 'nome'],
    )
  }

  render () {
    return (
      <Funcao
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleFuncao={this.props.multipleFuncao}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({ funcao, status, sort, filter }) {
  const sortColumn = sort.getIn(['funcao', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['funcao', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['funcao', 'filterText']) || ''

  let map = filterMap(funcao, ['nome'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleFuncao: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['funcao', 'error']),
    isLoading: status.getIn(['funcao', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...flashMessageAcionCreators,
    ...funcaoActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FuncaoContainer)
